/**
 * Hook que consulta /api/apps y devuelve el catálogo filtrado por los
 * grupos Entra del usuario actual (el filtrado lo hace el backend).
 */

import { useQuery } from '@tanstack/react-query';

import { api, ApiError } from '@/api/client';

export interface AppEntry {
  id: number;
  slug: string;
  name: string;
  url: string;
  icon_url: string | null;
  description: string | null;
  category: string | null;
  subcategory: string | null;
  is_public: boolean;
  enabled: boolean;
  /** "redirect" | "proxy" | "mockup" (prototipo servido como ruta interna). */
  auth_mode: string;
  created_at: string;
  updated_at: string;
}

export function useApps() {
  return useQuery<AppEntry[], ApiError>({
    queryKey: ['apps'],
    queryFn: () => api<AppEntry[]>('/api/apps/'),
    retry: false,
  });
}
